/**
 * What an admin is asked before deleting a user.
 *
 * DELETE /admin/users/:id is a hard delete: the row is removed for good. Since
 * 20261006b the database keeps every person's recorded history (check-ins,
 * case events, notes, sales...), so the delete only succeeds for someone with
 * none; for anyone else the server answers 409 and says what to do instead
 * (deactivate, or reassign their open cases first). The old text promised
 * "This action will deactivate their account", which it never did.
 */

/** A person's display name: first and last name, else the email, else a neutral word. */
export function personName(user: { first_name?: string | null; last_name?: string | null; email?: string | null } | null | undefined): string {
  if (!user) return 'this user';
  const name = [user.first_name, user.last_name].map((p) => (p || '').trim()).filter(Boolean).join(' ');
  return name || (user.email || '').trim() || 'this user';
}

/** The confirm text for the hard delete. */
export function deleteUserConfirmText(name: string): string {
  return `Permanently delete ${name}? This removes the account for good and is only possible for someone with no recorded history. To keep someone's history, deactivate the account instead.`;
}
